import { EyeCareMode } from '../data-models/camera/eyeCareMode.model';

export enum DeviceMonitorStatus {
	MicrophoneStatus = '[DeviceMonitorStatus] MicrophoneStatus',
	EyeCareModeStatus = '[DeviceMonitorStatus] EyeCareModeStatus',
	CameraStatus = '[DeviceMonitorStatus] CameraStatus',
	OOBEStatus = '[DeviceMonitorStatus] OOBEStatus'
}
